const CommonData = {
    state: {
        maskBox: false,
        padWarnShow: false,
        name: "",
        userType: "",
        icodeName: "ICode2020",
        isLogin: false,
        currentUser: "",
    },
    actions: {
        updateICodeName({ commit, state }) {
            return new Promise((resolve, reject) => {
                if (state.maskBox == true) {
                    reject(error);
                    return;
                }
                commit("SET_ICOCE_NAME", "ICode2021");
                resolve();
            });
        },
        updateMaskBox({ commit, state }) {

        },
        updateIsLOGIN({ commit, state }) {

        }
    },
    mutations: {
        SET_ICOCE_NAME: (state, name) => {
            state.icodeName = name;
        },
        toggleMaskState: (state, value) => {
            state.maskBox = value;
        },
        setUserType: (state, value) => {
            state.userType = value;
        },
        setUserName: (state, value) => {
            state.name = value;
        }
    }
};
export default CommonData


// WEBPACK FOOTER //
// ./src/store/CommonData.js